// 统计
import * as activity from 'activityConfigES';
import $ from 'jquery';
export const swiperInit = function () {
  let cardSwiper = new Swiper('.top-box .swiper-container', {
    loop: false,
    autoplay: false,
    slidesPerView: 5,
    spaceBetween: 10,
    navigation: {
      nextEl: '.top-box .swiper-button-next',
      prevEl: '.top-box .swiper-button-prev',
    },
  });
  let mcardSwiper = new Swiper('.mtop-box .swiper-container', {
    loop: false,
    autoplay: false,
    slidesPerView: 2,
    spaceBetween: 10,
    loopedSlides: 9,
    navigation: {
      nextEl: '.mtop-box .swiper-button-next',
      prevEl: '.mtop-box .swiper-button-prev',
    },
  });
  let dateSwiper = new Swiper('.schedule-box .swiper-container', {
    loop: false,
    autoplay: false,
    slidesPerView: 4,
    spaceBetween: 7,
    navigation: {
      nextEl: '.schedule-box .swiper-button-next',
      prevEl: '.schedule-box .swiper-button-prev',
    },
  });
  let mdateSwiper = new Swiper('.m .schedule-box .swiper-container', {
    loop: false,
    autoplay: false,
    slidesPerView: 5,
    spaceBetween: 10,
    navigation: {
      nextEl: '.m .schedule-box .swiper-button-next',
      prevEl: '.m .schedule-box .swiper-button-prev',
    },
  });
  let hdateSwiper = new Swiper('.h .schedule-box .swiper-container', {
    loop: false,
    autoplay: false,
    slidesPerView: 4,
    spaceBetween: 5,
    navigation: {
      nextEl: '.h .schedule-box .swiper-button-next',
      prevEl: '.h .schedule-box .swiper-button-prev',
    },
  });
  const shopSwiper = new Swiper('.part3 .swiper-container', {
    watchSlidesProgress: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    loopedSlides: 4,
    autoplay: true,
    navigation: {
      nextEl: '.part3 .swiper-button-next',
      prevEl: '.part3 .swiper-button-prev',
    },
    pagination: {
      el: '.part3 .swiper-pagination',
      clickable: true,
    },
    on: {
      progress: function () {
        for (let i = 0; i < this.slides.length; i++) {
          let slide = this.slides.eq(i);
          let slideProgress = this.slides[i].progress;
          let modify = 1;
          if (Math.abs(slideProgress) > 1) {
            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
          }
          let translate = ((slideProgress * modify * 442) / 1080) * 100 + 'vh';
          let scale = 1 - Math.abs(slideProgress) / 5;
          let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
          slide.transform('translateX(' + translate + ') scale(' + scale + ')');
          slide.css('zIndex', zIndex);
          slide.css('opacity', 1);
          if (Math.abs(slideProgress) > 3) {
            slide.css('opacity', 0);
          }
        }
      },
      setTransition: function (transition) {
        for (let i = 0; i < this.slides.length; i++) {
          let slide = this.slides.eq(i);
          slide.transition(transition);
        }
      },
      resize() {
        let width = $('.part3 .swiper-container').width();
        $('.part3 .swiper-container img').css('width', `${width}px`);
      },
    },
  });
};
export const init = function () {
  swiperInit();
  activity.stat();
};
